<template>
  <div>
    <div class="section">
      <div class="container is-small">
        <h1 class="title">
          Nous joindre
        </h1>
        <h2 class="subtitle">
          Questions ou commentaires? Veuillez nous joindre avec le formulaire ci-dessous.
        </h2>
        <div>
          <transition
            name="scale"
            mode="out-in"
          >
            <form
              v-if="!sent"
              v-loading="loading"
              class="form"
              @submit.prevent="send()"
            >
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label
                      for=""
                      class="label"
                    >Nom</label>
                    <input
                      v-model="form.name"
                      class="input"
                      type="text"
                      name="name"
                      required
                    >
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label
                      for=""
                      class="label"
                    >Courriel</label>
                    <input
                      v-model="form.email"
                      class="input"
                      type="email"
                      name="email"
                      required
                    >
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">Message</label>
                <textarea
                  v-model="form.message"
                  cols="20"
                  rows="5"
                  class="textarea"
                  minlength="3"
                  required 
                />
              </div>

              <button class="button is-medium is-primary mt-20">
                Envoyer
              </button>
            </form>
            <div
              v-else
              class="sent has-text-centered"
            >
              <div>
                <span class="icon is-large has-text-success">
                  <i class="mdi mdi-checkbox-marked-circle-outline mdi-48px" />
                </span>
                <br>
                <h3 class="title is-3">
                  Message envoyé avec succès
                </h3>
                <h4 class="subtitle is-5">
                  Nous allons vous répondre aussi vite que possible
                </h4>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
	data () {
		return {
			form: {
				name: "",
				email: "",
				message: ""
			},
			sent: false,
			loading: false,
		};
	},
	methods: {
		send () {
			this.loading = true;
			this.sendRequest();
		},
		sendRequest() {
			axios.post(
				"https://mailer.witify.io/api/mail/submit",
				{
					subject: "Nouveau message sur l'interface Muzlink",
					data: this.form
				},
				{
					headers: {Authorization: "Bearer $2y$10$c0sKHGRP0VIxqIk302JO6etkEPFHLn1KsJ93w.Ox7Nx4ddcYXF3Da"}
				}
			)
				.then(response => {
					this.sent = true;
					this.loading = false;
				})
				.catch(error => {
					this.loading = false;
					alert("Le formulaire de contact de fonctionne pas actuellement. Veuillez nous joindre directement à jean-f.gauvin@banq.qc.ca.");
				});
		}
	}
};
</script>

<style scoped>
.sent {
    padding: 30px 0;
}
</style>
